if($('.type-detail').length){
    $('.p-info-wrapper').append($('.p-detail-inner-header').clone())
    $('.p-info-wrapper').append('<div class="customCart"></div>')
    $('.customCart').append($('.p-info-wrapper .p-final-price-wrapper'))
    $('.customCart').append($('.p-info-wrapper .add-to-cart'))
    $('.add-to-cart-button').html('<span>Koupit</span>')
    $('#p-detail-tabs li').each(function(){
        $(this).addClass($(this).text().normalize('NFD').replace(/[^\w]/g, '').toLowerCase())
    })
    if($('#productVideos').length){
        $('#productVideos iframe').each(function(){
            $(this).wrap('<div class="video"></div>')
           // $(this).append('<h4>'+$(this).attr('title')+'</h4>')
        })
    }
    $('.p-info-wrapper').append('<div class="customContact"><span class="customInfoPopup" data-url="/'+deliveryTime+'/">Termín dodání - zjistit více</span></div>')
    if($('.p-detail-info .flag-moznost-jine-barvy').length){
        $('.p-info-wrapper').append('<div class="customColor"><span class="customInfoPopup" data-url="/'+colorUrl+'/">Máte zájem o jinou barevnost?</span><p>'+ColorText+'</p></div>')
    }

    $(document).on('click', '.customInfoPopup', function(){
        $.ajax({
            url: $(this).attr('data-url'),
            type: 'GET',
            success: function(response) {
                var content = $(response).find('.content-inner article').html();
                $.colorbox({
                    html: '<div class="texrminWrap">'+content+'</div>',
                    width: 500,
                    maxWidth: "95%",
                    height: 500,
                    maxHeight: "95%",
                    className: "colorboxDodani",
                    onComplete: function() {
                    }
                });
            },
            error: function() {
                console.log('Chyba při načítání obsahu.');
            }
        });
    });
    $('.basic-description').each(function(){
        if($('p:contains("#pece-o-produkt#")').length){
            if($('#p-detail-tabs').length){
                $('#p-detail-tabs li').first().after('<li class="shp-tab pece-o-produkt" data-width=""><a href="#pece-o-produkt" class="shp-tab-link" role="tab" data-toggle="tab">Péče o produkt</a></li>')
                $('#tab-content.tab-content').append('<div id="pece-o-produkt" class="tab-pane fade" role="panel"></div>')    
            }
            if($('#accordion-content').length){
                $('#accordion-content').append('<div class="shp-accordion"><a href="#size" class="shp-accordion-link"><span>Péče o produkt</span></a><div class="shp-accordion-content"><div id="pece-o-produkt" class="tab-pane fade" role="tabpanel"></div></div></div>')
            }
            var element_nutricni_info = $('p:contains("#pece-o-produkt#")').nextUntil().nextAll('p:contains("#pece-o-produkt-konec#")').andSelf()
            $(element_nutricni_info).appendTo('#pece-o-produkt')
            $('p:contains("#pece-o-produkt#")').remove()
            $('p:contains("#pece-o-produkt-konec#")').remove()
        }
        if($('p:contains("#technicka-specifikace#")').length){
            if($('#p-detail-tabs').length){
                $('#p-detail-tabs li').first().after('<li class="shp-tab technicka-specifikace" data-width=""><a href="#technicka-specifikace" class="shp-tab-link" role="tab" data-toggle="tab">Technická specifikace</a></li>')
                $('#tab-content.tab-content').append('<div id="technicka-specifikace" class="tab-pane fade" role="panel"></div>')    
            }
            if($('#accordion-content').length){
                $('#accordion-content').append('<div class="shp-accordion"><a href="#size" class="shp-accordion-link"><span>Technická specifikace</span></a><div class="shp-accordion-content"><div id="technicka-specifikace" class="tab-pane fade" role="tabpanel"></div></div></div>')
            }
            var element_nutricni_info = $('p:contains("#technicka-specifikace#")').nextUntil().nextAll('p:contains("#technicka-specifikace-konec#")').andSelf()
            $(element_nutricni_info).appendTo('#technicka-specifikace')
            $('p:contains("#technicka-specifikace#")').remove()
            $('p:contains("#technicka-specifikace-konec#")').remove()
        }
        if($('p:contains("#galerie-specifikace#")').length){
            pocetfotek = $('.plus-gallery-wrap .plus-gallery-item').length
            if($('#p-detail-tabs').length){
                $('#p-detail-tabs li').first().after('<li class="shp-tab galerie-specifikace" data-width=""><a href="#galerie-specifikace" class="shp-tab-link" role="tab" data-toggle="tab">Foto ('+pocetfotek+')</a></li>')
                $('#tab-content.tab-content').append('<div id="galerie-specifikace" class="tab-pane fade" role="panel"></div>')    
            }
            if($('#accordion-content').length){
                $('#accordion-content').append('<div class="shp-accordion"><a href="#size" class="shp-accordion-link"><span>Foto ('+pocetfotek+')</span></a><div class="shp-accordion-content"><div id="galerie-specifikace" class="tab-pane fade" role="tabpanel"></div></div></div>')
            }
            var galspec = $('p:contains("#galerie-specifikace#")').nextUntil().nextAll('p:contains("#galerie-specifikace-konec#")').andSelf()
            $(galspec).appendTo('#galerie-specifikace')
            $('p:contains("#galerie-specifikace#")').remove()
            $('p:contains("#galerie-specifikace-konec#")').remove()
        }
        
    });

    if($('#tab-content #productsAlternative').length){
      
        $('#tab-content').after($('#productsAlternative'))
    }


    if($('.surcharge-list select.surcharge-parameter[data-parameter-id="19"]').length>0){
        $('.surcharge-list select').each(function(){
            if($('.surcharge-list').find('th .show-tooltip').length){
                var listTootip = $('.surcharge-list').find('th .show-tooltip').attr('title')
            }
            else{
                listTootip = ''
            }
            var optionLength = $(this).find('option').length
            var data_parameter_id = $(this).data('parameter-id')
            var html_var = '<div class="custom-variant" data-groupId="'+data_parameter_id+'"><div class="h3">'+$(this).attr('data-parameter-name')
            if(listTootip !== ''){
                if(textsplit[1] !== '0 Kč'){
                    html_var += '<span class="show-tooltip question-tooltip" title="'+listTootip+'">?</span>'
                }
            }
            html_var += '</div>'
            html_var += '<div class="custom-variant-wrap" data-param-id="'+data_parameter_id+'">'
            $(this).find('option').each(function(){
                var data_value = $(this).attr('value')
                if ($.isNumeric($(this).val())) {
                    var textsplit = $(this).text().split('+')
                    html_var += '<div class="variant" data-value="'+data_value+'" data-parameter-id="'+data_parameter_id+'" data-param-val="'+data_parameter_id+'-'+data_value+'">'
                    html_var += '<div class="text">'
                        html_var += textsplit[0]                 
                    html_var += '</div>'
                    html_var += '</div>'
                }
            })
            html_var += '</div>'            
            html_var += '</div>'
            $(this).closest('tr').after(html_var)
            $(this).closest('tr').hide()
          
        })

        var necessaryVariantData = shoptet.variantsSplit.necessaryVariantData;
        for (var parentKey in necessaryVariantData) {
            if (necessaryVariantData.hasOwnProperty(parentKey)) {
                var variant = necessaryVariantData[parentKey];
                $('.custom-variant-wrap .variant[data-param-val="'+parentKey+'"]').attr('data-price-id', variant.id).attr('data-avail', variant.availabilityName.normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/ /g, '-'))
            }
        }
        
    }


    $(document).on('click', '.custom-variant-wrap .variant', function(){
        const variantData = $(this).data('value');
        const variantParameterId = $(this).data('parameter-id');
    
        // Změna pro data-parameter-id 281 a třídu active
        if($(this).attr('data-parameter-id') === '281' && $(this).hasClass('active')){
            $("select[data-parameter-id='281'] option:first").prop("selected", true).change();
            $(this).removeClass("active"); 
        } else {
            // Původní chování pro ostatní případy
            $("select[data-parameter-id='"+variantParameterId+"'] option").filter(function (){
                return $(this).attr('value') == variantData;
            }).change().prop("selected", true);
            $(this).closest('.custom-variant-wrap[data-param-id="'+variantParameterId+'"]').find(".variant:not([data-value='"+variantData+"'])").removeClass("active");
            $(this).addClass("active"); 
        }
    
        var selector = '.variant-list .hidden-split-parameter, .variant-list .split-parameter';
        var $splitParameters = $(selector);
        $splitParameters.trigger('change'); 
    
        $("select[data-parameter-id='"+variantParameterId+"']")[0].dispatchEvent(new Event('change'));
    
        $('.custom-variant-wrap .variant').each(function(){
            const variantData = $(this).data('value');
            const variantParameterId = $(this).data('parameter-id');
            const unavailable = $("select[data-parameter-id='"+variantParameterId+"'] option[value='" + variantData + "']").hasClass("unavailable-option");
            if (unavailable === true) {
                $(this).addClass("unavailable").removeClass("active");
            }
            else{
                $(this).removeClass("unavailable");
            } 
        });
    });

    $(document).ready(function(){
        $('.custom-variant-wrap .variant[data-param-val="19-25"]').trigger('click');
    })




}